// External Imports
import React from 'react';

import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';

//Alert View
export default function RequestingAlert({ variant = 'info' }) {
  return (
    <Alert variant={variant}>
      <Spinner animation='border' role='status'>
        <span className='visually-hidden'>Requesting...</span>
      </Spinner>
      <span>Your request is being processed.</span>
    </Alert>
  );
}
